import { Subject } from 'rxjs'
import { filter, map, bufferTime } from 'rxjs/operators'
import pako from 'pako'
import EventEmitter from 'eventemitter3'
import * as Sentry from '@sentry/browser'
import { NORMAL_SUBSCRIBE_MAP, WORKER_MSG_TOPIC } from './workerConfig'
import { COOKIE_NAME } from '~/frontend-shared/helper/login-util';
import { getCurHost } from '~/frontend-shared/helper/dom';

// 私有订阅
export const AccessSubscribes = [
  'unicast',
  'position',
  'asset:USDT',
  'asset:follower:USDT',
];
const SENTRY_ENABLE =
  process.env.NODE_ENV === 'production' && ['testing', 'production'].includes(process.env.domain_env)

// if (SENTRY_ENABLE) {
//   Sentry.init({
//     dsn: 'https://6dc1196ced1c46dca7e7361db6c26fa4@o687438.ingest.sentry.io/5779661',
//     release: process.env.release,
//     sampleRate: 0.2,
//     environment: process.env.domain_env,
//   })
// }

// let authorization: string;
const getAccessKeys = async () => {
  /**  老的Token如果有则兼容赋值到 headers.Authorization === START ===稳定后删除 */

  const headers = {
    'X-BM-CLIENT': 'WEB',
    'X-BM-DEVICE': '1',
    'X-BM-VERSION': '1.0.0',
  }
  const oldToken = window.$nuxt.$cookies.get(COOKIE_NAME.TOKEN);
  if (oldToken) {
    headers.Authorization = oldToken;
  }
  /**  老的Token如果有则兼容赋值到 headers.Authorization === END ===稳定后删除 */
  const raw = await fetch('/gw-api/contract-tiger/account/listenKey', {
    headers,
  });
  const res = await raw.json();
  if (res.success) {
    const { accessKey, expireTs, sign, ts } = res.data;
    // @refer: https://bitmart.atlassian.net/wiki/spaces/DEVELOPMEN/pages/1931608104/WebSocket+API
    return [
      accessKey,
      'web',
      '1.0.0',
      sign,
      ts,
      expireTs,
    ];
  }
  return false;
};
class WsSubject extends EventEmitter {
  constructor () {
    super()
    this.retryTimes = 0
    this.subjectMap = new Map()
    this.subject = new Subject()
    // this.connect()
    // window.onNuxtReady(() => {
    //   this.url = `${window.$nuxt.$curHost?.wssHostV2}/v1/ifcontract/realTime`
    // })
  }

  close (code, reason) {
    this.ws.close(code, reason)
  }

  manualClose() {
    if (this.heartBeat) {
      clearTimeout(this.heartBeat)
      this.heartBeat = null
    }
    if (this.connectTimer) {
      clearTimeout(this.connectTimer)
      this.connectTimer = null
    }
    this.ws?.close(1000, 'manual close')
  }

  connect() {
    let wsUrl = '';
    if (import.meta.client) {
      const $curHost = getCurHost(window.location.origin) ?? {}
      wsUrl = $curHost.wssHostV2;
    }
    this.url = `${wsUrl}/v1/ifcontract/realTime`
    this.ws = new WebSocket(wsUrl)
    // setTimeout(() => {
    //   if (this.url != `${window.$nuxt.$curHost?.wssHostV2}/v1/ifcontract/realTime`) {
    //     setTimeout(this.ws?.close)
    //   }
    // }, 3000)
    this.ws.binaryType = 'arraybuffer'
    if (this.heartBeat) {
      clearTimeout(this.heartBeat)
      this.heartBeat = null
    }
    this.ws.onclose = (event) => {
      if (event.code === 1000) {
        return
      }
      if (!event.wasClean && event.code !== 1006) {
        SENTRY_ENABLE &&
          Sentry.captureMessage(`websocket close occurred (code: ${event.code}, reason:${event.reason})`, 'warning')
      }
      this.reconnect()
    }
    this.ws.onerror = (event) => {
      // console.log('onerror')
      // SENTRY_ENABLE && Sentry.captureMessage(`websocket error occurred: ${event.data}`, 'warning')
      this.ws?.close()
    }
    this.ws.onopen = () => {
      this.retryTimes = 0
      const subscribeArgs = []
      for (const argValue of this.subjectMap.keys()) {
        if (Array.isArray(argValue)) {
          subscribeArgs.push(...argValue)
        } else if (argValue) {
          subscribeArgs.push(argValue)
        }
      }
      if (subscribeArgs.length) {
        this.send({
          action: WORKER_MSG_TOPIC.get('SUBSCRIBE'),
          args: subscribeArgs,
        })
      }
    }
    this.ws.onmessage = (event) => {
      this.initHeartBeat()
      if (event.data) {
        try {
          let wsres
          if (event.data.search && event.data.replace) {
            try {
              wsres = JSON.parse(event.data)
            } catch (e) {
              Sentry.captureException(e)

              return
            }
          } else {
            wsres = pako.inflateRaw(event.data, {
              to: 'string',
            })
            wsres = JSON.parse(wsres)
          }
          if (wsres.code !== undefined && +wsres.code !== 0) {
            return
          }
          this.subject.next(wsres)
          wsres = null
        } catch (err) {
          SENTRY_ENABLE && Sentry.captureMessage(err, 'warning')
        }
      }
    }
  }

  reconnect () {
    const timeout = Math.pow(2, Math.round(this.retryTimes / 10))
    if (this.retryTimes <= 23) {
      this.retryTimes += 1
    }
    if (this.retryTimes === 23) {
      SENTRY_ENABLE && Sentry.captureMessage(`websocket reconnect ${this.retryTimes} times`, 'warning')
    }
    if (this.connectTimer) {
      clearTimeout(this.connectTimer)
    }
    this.connectTimer = setTimeout(() => {
      this.connect()
    }, timeout * 1e3)
  }

  initHeartBeat () {
    if (this.heartBeat) {
      clearTimeout(this.heartBeat)
    }
    this.heartBeat = setTimeout(() => {
      this.send({
        action: 'ping',
      })
    }, 20000)
  }

  send (subject) {
    if (this.ws?.readyState === 1) {
      this.ws?.send(JSON.stringify(subject))
    }
  }

  /**
   * 发起订阅，如果已经订阅过，则不会重复订阅，目前只需要订阅ticker，没有复杂逻辑
   * @param {*} subData
   */
  subscribe (action, subData, actionKey) {
    if (action === WORKER_MSG_TOPIC.get('ACCESS')) {
      const actionArgs = this.subjectMap.get(WORKER_MSG_TOPIC.get('ACCESS'));
      subData.forEach(arg => {
        // 私有订阅不需要存
        if (!AccessSubscribes.includes(arg)) {
          actionArgs?.add(arg);
        }
      });
      this.send({
        action: actionKey || action,
        args: subData,
      });
    } else {
      const subscribeArgs = []
      subData.forEach((nextArg) => {
        if (!this.subjectMap.has(nextArg)) {
          subscribeArgs.push(nextArg)
          this.subjectMap.set(nextArg, true)
        }
      })
      this.send({
        action: WORKER_MSG_TOPIC.get('SUBSCRIBE'),
        args: subscribeArgs,
      })
    }
  }

  /**
   * 取消订阅, 目前只需要订阅ticker，没有复杂逻辑，所以只做了判断是否之前订阅过
   * @param {*} subData
   */
  unsubscribe (subData) {
    const unsubscribeArgs = []
    subData.forEach((nextArg) => {
      if (this.subjectMap.has(nextArg)) {
        unsubscribeArgs.push(nextArg)
        this.subjectMap.delete(nextArg)
      }
    })
    this.send({
      action: WORKER_MSG_TOPIC.get('UNSUBSCRIBE'),
      args: unsubscribeArgs,
    })
  }
}

export const ws = new WsSubject()

ws.on('message', async(msg) => {
  const payload = msg.payload ? JSON.parse(JSON.stringify(msg.payload)) : []
  switch (msg.type) {
    case WORKER_MSG_TOPIC.get('ACCESS'):
      if (!ws.ws || ws.ws.readyState === WebSocket.CLOSED || ws.ws.readyState === WebSocket.CLOSING) {
        ws.connect()
      }
      // eslint-disable-next-line no-case-declarations
      const keys = await getAccessKeys();
      if (Array.isArray(keys)) {
        ws.subjectMap.get(WORKER_MSG_TOPIC.get('ACCESS'))?.clear();
        setTimeout(() => {
          ws.subscribe(msg.type, keys);
        }, 1000)
      }
      break;
    case WORKER_MSG_TOPIC.get('SUBSCRIBE'):
      if (!ws.ws || ws.ws.readyState === WebSocket.CLOSED || ws.ws.readyState === WebSocket.CLOSING) {
        ws.connect()
      }
      ws.subscribe(msg.type, payload)
      break
    case WORKER_MSG_TOPIC.get('UNSUBSCRIBE'):
      if (!ws.ws) {
        ws.connect()
      }
      ws.unsubscribe(payload)
      break
  }
})

// function postMsg(type, payload) {
//   if (supportTextEncoder) {
//     const encoder = new TextEncoder()
//     const ab = encoder.encode(
//       JSON.stringify({
//         type,
//         payload,
//       })
//     )
//     self.postMessage(ab, [ab.buffer])
//   } else {
//     self.postMessage({
//       type,
//       payload,
//     })
//   }
// }z

ws.subject
  .pipe(
    filter(ev => ev.group === 'Ticker' && ev?.data),
    map(ev => ({
      ...ev?.data,
    })),
    // 每 0.5s 更新一次
    bufferTime(200, null),
  )
  .subscribe((bufferList) => {
    // postMsg('PRICE_LIST', bufferList)
    if (!bufferList || bufferList.length === 0) {
      return
    }
    ws.emit('postMessage', {
      type: 'FUTURES_PRICE_LIST',
      payload: bufferList,
    })
  })

ws.subject.pipe(filter(ev => NORMAL_SUBSCRIBE_MAP.has(ev.group || ev.action) || AccessSubscribes.includes(ev.group))).subscribe((ev) => {
  if (ev.success) {
    if (ev.action === 'access') {
      // 验证成功后，发起私有数据订阅
      ws.subscribe(WORKER_MSG_TOPIC.get('ACCESS'), AccessSubscribes, WORKER_MSG_TOPIC.get('SUBSCRIBE'));
    }
  } else if (ev.action === 'access') {
    // 订阅私有数据失败，刷新 key
    ws.subjectMap.get(WORKER_MSG_TOPIC.get('ACCESS'))?.clear();
    WsSubject.reAuthTimer && clearTimeout(WsSubject.reAuthTimer);
    WsSubject.reAuthTimer = setTimeout(async () => {
      const keys = await getAccessKeys();
      if (Array.isArray(keys)) {
        ws.subscribe(WORKER_MSG_TOPIC.get('ACCESS'), keys);
      }
    }, 5000);
  } else {
    // SENTRY_ENABLE && Sentry.captureMessage(new Error(ev.error || ev.action).toString(), 'warning');
  }
  // postMsg(NORMAL_SUBSCRIBE_MAP.get(ev.subscribe), ev)
  ws.emit('postMessage', {
    type: NORMAL_SUBSCRIBE_MAP.get(ev.group),
    payload: ev,
  })
})
